import { render, staticRenderFns } from "./FavoritePanel.vue?vue&type=template&id=1818d646&scoped=true"
import script from "./FavoritePanel.vue?vue&type=script&lang=js"
export * from "./FavoritePanel.vue?vue&type=script&lang=js"
import style0 from "./FavoritePanel.vue?vue&type=style&index=0&id=1818d646&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1818d646",
  null
  
)

export default component.exports